import * as Immutable from 'immutable';
import * as ActionTypes from '../constants/ActionTypes';

const merchantState = Immutable.fromJS({
  claiming: false,
  claimed: false,
  claim_code: null,
  invite_code: null
});

function setState(state, newState) {
  return state.merge(newState);
}

export function merchant(state = merchantState, action) {
  switch(action.type) {
    case ActionTypes.SET_INVITE_CODE:
      return setState(state, state.set('invite_code', action.payload));

    case ActionTypes.REQUEST_CLAIM:
      return setState(state, state.set('claiming', action.payload));

    case ActionTypes.RESET_MERCHANT:
      return merchantState;

    case ActionTypes.VALIDATE_CLAIM:
      return setState(state, state.set('claim_code', action.payload));

    default:
      return state;
  }
}



// WEBPACK FOOTER //
// ./src/reducers/merchant.js